<template>
  <div class="content-i">
    <div class="content-box">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a :class="{'active': tab === 'Receber'}" @click.stop="tab = 'Receber'" class="nav-link" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">A receber</a>
        </li>
        <li class="nav-item">
          <a :class="{'active': tab === 'Pagar'}" @click.stop="tab = 'Pagar'" class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">A Pagar</a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div :class="{'show': tab === 'Receber', 'active': tab === 'Receber'}" class="tab-pane fade" id="home" role="tabpanel" aria-labelledby="home-tab">
          <receber v-if="tab === 'Receber'"></receber>
        </div>
        <div :class="{'show': tab === 'Pagar', 'active': tab === 'Pagar'}" class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
          <pagar v-if="tab === 'Pagar'"></pagar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Receber from './Receber'
import Pagar from './Pagar'
export default {
  components: {
    Receber,
    Pagar
  },
  data () {
    return {
      tab: 'Receber'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/financeiro/FinanceiroForm.vue